import { render, staticRenderFns } from "./activity-card.vue?vue&type=template&id=481ec2e4&"
import script from "./activity-card.ts?vue&type=script&lang=ts&"
export * from "./activity-card.ts?vue&type=script&lang=ts&"
import style0 from "./activity-card.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports